import { gql } from '@apollo/client';
import type { ReplacePostPath_PostFragment } from '../../graphql/generated/graphqlTypes';
import type { NavigateFunction } from '../../utils/router/useNavigate';
import postPath, { publicPostPath } from '../../utils/url/postPath';

const REPLACE_POST_PATH_FRAGMENT = gql`
  fragment replacePostPath_post on PublicPostFields {
    ...postPath_post
  }
  ${postPath.fragments.post}
`;

const getPostPath = (
  post: ReplacePostPath_PostFragment,
  publicPath?: boolean,
) => {
  return publicPath ? publicPostPath(post) : postPath(post);
};

const replacePostPath = (
  post: ReplacePostPath_PostFragment | string,
  navigate: NavigateFunction,
  publicPath?: boolean,
) => {
  const path = typeof post === 'string' ? post : getPostPath(post, publicPath);
  if (path !== document.location.pathname) {
    navigate(path + document.location.hash, { replace: true });
  }
};

replacePostPath.fragments = {
  post: REPLACE_POST_PATH_FRAGMENT,
};

export default replacePostPath;
